import i18n from "@/lang/i18n";
// import axios from "@/modules/FastLineLite/axios-middleware";
import axios from "axios";
import Vue from "vue";

const base = `${process.env.VUE_APP_CONSTRUCTOR_URL}/kw/fastline_pro`;

const state = {
  fast_line_lite:{
		ai_agents_list: [],
		current_ai_agent: {},

		data_sets_list: [],
		data_sets_process_rule: {},

		current_data_set: {
			id: null,
			documents: [],
		},
		current_data_set_documents: [],
		current_dataset_document_segments: [],

		model_types_llm: [],

		current_model_param_rules: [],
  }
};

const mutations = {
	SET_FLL_AI_AGENTS_LIST(state, payload){
		state.fast_line_lite.ai_agents_list = payload;
	},
	SET_FLL_CURRENT_AI_AGENT(state, payload){
		Vue.set(
			state.fast_line_lite,
			'current_ai_agent',
			payload
		)
		// state.fast_line_lite.current_ai_agent = payload;
	},

	SET_FLL_DATA_SETS_LIST(state, payload){
		state.fast_line_lite.data_sets_list = payload;
	},
	SET_DATA_SETS_PROCESS_RULE(state, payload){
		state.fast_line_lite.data_sets_process_rule = payload;
	},
	SET_FLL_CURRENT_DATA_SET(state, payload){
		state.fast_line_lite.current_data_set = payload;
	},
	SET_FLL_CURRENT_DATA_SET_DOCUMENTS(state, payload){
		state.fast_line_lite.current_data_set_documents = payload;
	},

	SET_FLL_CURRENT_DATASET_DOCUMENT_SEGMENTS(state, payload){
		state.fast_line_lite.current_dataset_document_segments = payload;
	},

	ADD_NEW_VARIABLE_AGENT_AI_CONFIG(state) {
		state.fast_line_lite.current_ai_agent.variables.push({
			variable: '',
			label: '',
			is_new: true,
			uid: state.fast_line_lite.current_ai_agent.variables.length
		})
	},
	UPDATE_AGENT_AI_CONFIG_VARIABLE(state, { itemId, value }) {
		const agent = state.fast_line_lite.current_ai_agent;
		if (!agent || !agent.variables) return;

		const itemIndex = agent.variables.findIndex(v => v.uid === itemId);

		if (itemIndex !== -1) {
			if (agent.variables[itemIndex].variable !== value) {
				agent.variables[itemIndex].variable = value;
			}
		}
	},
	UPDATE_AGENT_AI_CONFIG_DATASETS(state, {dataset_ids}) {
		if(!state.fast_line_lite.current_ai_agent.dataset_configs.hasOwnProperty('datasets')) {
			Vue.set(
				state.fast_line_lite.current_ai_agent.dataset_configs,
				'datasets',
				{}
			)
		}

		if(!state.fast_line_lite.current_ai_agent.dataset_configs.datasets.hasOwnProperty('datasets')) {
			Vue.set(
				state.fast_line_lite.current_ai_agent.dataset_configs.datasets,
				'datasets',
				[]
			)
		}

		if(dataset_ids?.length) {
			const arr = []

			for (let i in dataset_ids) {
				arr.push({
					dataset: {
						enabled: true,
						id: dataset_ids[i]
					}
				})
			}
			state.fast_line_lite.current_ai_agent.dataset_configs.datasets.datasets = arr
		} else {
			state.fast_line_lite.current_ai_agent.dataset_configs.datasets.datasets = []
		}
	},
	DELETE_AGENT_AI_CONFIG_DATASETS(state, dataset_id) {
		const datasets = state.fast_line_lite.current_ai_agent.dataset_configs.datasets.datasets
		if(!datasets?.length) return

		const itemIndex = datasets.findIndex(v => v?.dataset?.id === dataset_id);

		if (itemIndex !== -1 && itemIndex < datasets.length) {
			datasets.splice(itemIndex, 1);
		}
	},

	UPDATE_AGENT_AI_CONFIG_MODEL(state, data) {
		const {
			model,
			mode,
			provider,
			completion_params,
		} = data

		state.fast_line_lite.current_ai_agent.model['name'] = model
		state.fast_line_lite.current_ai_agent.model['mode'] = mode
		state.fast_line_lite.current_ai_agent.model['provider'] = provider
		state.fast_line_lite.current_ai_agent.model['completion_params'] = completion_params
	},

	UPDATE_AGENT_AI_CONFIG_MODEL_PARAM_RULE(state, data) {
		const {
			key,
			value,
			event
		} = data

		switch(event) {
			case 'update':
				// state.fast_line_lite.current_ai_agent.model.completion_params[key] = value
				Vue.set(
					state.fast_line_lite.current_ai_agent.model.completion_params,
					key,
					value
				)
				state.fast_line_lite.current_ai_agent.model.completion_params[key] = value
				break
			case 'delete':
				if(state.fast_line_lite.current_ai_agent.model.completion_params[key]) {
					console.log(state.fast_line_lite.current_ai_agent.model.completion_params, key, 888)
					delete state.fast_line_lite.current_ai_agent.model.completion_params[key]
				}
				break
			default:
				break;

		}
	},


	SET_MODEL_TYPES_LLM(state, payload) {
		state.fast_line_lite.model_types_llm = payload;
	},

	SET_CURRENT_MODEL_PARAM_RULES(state, payload) {
		state.fast_line_lite.current_model_param_rules = payload
	},
};

const actions = {
	updateAgentAIConfigModelParamRule({ commit }, data) {
		commit('UPDATE_AGENT_AI_CONFIG_MODEL_PARAM_RULE', data);
	},

  // AGENTS
  async getAxiosAiAgentsList({ commit }) {
    const res = await axios.get(`${base}/agents`);
    commit('SET_FLL_AI_AGENTS_LIST', res.data?.data || []);

		return res
  },
  async createAxiosAiAgent({ commit }, data) {
    const res = await axios.post(`${base}/agents`, data);
    return res?.data?.data || {};
  },
  async editAxiosAiAgent({ commit }, data) {
    if (!data?.id) return;
    const { id, ...rest } = data;
    const res = await axios.put(`${base}/agents/${id}`, rest);
    return res.data;
  },
  async deleteAxiosAiAgent({ commit }, { id }) {
    if (!id) return;
    const res = await axios.delete(`${base}/agents/${id}`);
    return res.data;
  },
	async getAxiosAiAgentConfig({ commit }, { id }) {
	  if (!id) return;

	  const res = await axios.get(`${base}/agents/${id}`);
	  const agent = res?.data?.data;

	  commit('SET_FLL_CURRENT_AI_AGENT', agent);
	},

	async updateAxiosAiAgentConfig({ commit }, data) {
	  if (!data?.id) return;

	  const res = await axios.post(`${base}/agents/${data.id}/config`, data);
	  return res.data;
	},

  //DATA SETS
  async axiosCreateDataSetInit({ commit }, data) {
    const res = await axios.post(`${base}/datasets/init`, data);
    return res.data;
  },

  async getAxiosDataSetsList({ commit }) {
    const params = { page: 1, limit: 300, include_all: true };
    const res = await axios.get(`${base}/datasets`, { params });
    commit('SET_FLL_DATA_SETS_LIST', res?.data?.data || []);

		return res
  },

  async axiosCreateDataSet({ commit }, data) {
    const res = await axios.post(`${base}/datasets`, data);
    return res.data;
  },

  async axiosUpdateDataSet({ commit }, data) {
    if (!data?.id) return;
    const { id, ...query } = data;
    const res = await axios.patch(`${base}/datasets/${id}`, query);
    return res.data;
  },

  async axiosDeleteDataSet({ commit }, id) {
    const res = await axios.delete(`${base}/datasets/${id}`);
    return res.data;
  },

  async getAxiosDataSet({ commit }, { id }) {
    if (!id) return;
    const res = await axios.get(`${base}/datasets/${id}`);
    commit('SET_FLL_CURRENT_DATA_SET', res?.data?.data || []);
  },

  async axiosAddDataSetDocument({ commit }, data) {
    const { dataset_id, ...rest } = data;
    const res = await axios.post(`${base}/datasets/${dataset_id}/documents`, rest);
    return res.data;
  },

  async getAxiosDataSetDocuments({ commit }, data) {
    const { id, query_params } = data;
    if (!id) return;
    const params = { page: 1, limit: 1000, ...query_params };
    const res = await axios.get(`${base}/datasets/${id}/documents`, { params });
    commit('SET_FLL_CURRENT_DATA_SET_DOCUMENTS', res?.data?.data || []);
  },

  async axiosEditDataSetDocumentRename({ commit }, data) {
    const { dataset_id, document_id, name } = data;
    const res = await axios.post(`${base}/datasets/${dataset_id}/documents/${document_id}/rename`, { name });
    return res.data;
  },

  async axiosEditDataSetDocumentStatus({ commit }, data) {
    const { dataset_id, document_ids, status } = data;
    const res = await axios.patch(`${base}/datasets/${dataset_id}/documents/status`, { document_ids, status });
    return res.data;
  },

  async axiosDeleteDataSetDocument({ commit }, data) {
    const { dataset_id, document_ids } = data;
    const res = await axios.delete(`${base}/datasets/${dataset_id}/documents`, { data: { document_ids } });
    return res.data;
  },
  //end DATA SETS

  // segments
  async getAxiosDataSetSegments({ commit }, data) {
const { id, document_id, query_params } = data;
if (!id) return;

const params = {
  page: 1,
  limit: 1000,
  ...query_params,
};

const res = await axios.get(`${base}/datasets/${id}/documents/${document_id}/segments`, { params });
commit('SET_FLL_CURRENT_DATASET_DOCUMENT_SEGMENTS', res?.data?.data || []);
},

  async createAxiosDataSetSegment({ commit }, data) {
    const { dataset_id, document_id, content } = data;
    const res = await axios.post(`${base}/datasets/${dataset_id}/documents/${document_id}/segment`, { content });
    return res.data;
  },

  async axiosEditDataSetDocumentSegment(_, data) {
    const { dataset_id, document_id, segment_id, content } = data;
    const res = await axios.patch(
      `${base}/datasets/${dataset_id}/documents/${document_id}/segments/${segment_id}`,
      { content }
    );
    return res.data;
  },

  async axiosEditDataSetDocumentSegmentsStatus(_, data) {
    const { dataset_id, document_id, segment_ids, status } = data;
    const res = await axios.patch(
      `${base}/datasets/${dataset_id}/documents/${document_id}/segments/status/batch`,
      { segment_ids, status }
    );
    return res.data;
  },

  async axiosDeleteDataSetDocumentSegment(_, data) {
    const { dataset_id, document_id, segment_id } = data;
    const res = await axios.delete(`${base}/datasets/${dataset_id}/documents/${document_id}/segments`, {
      params: { segment_id },
    });
    return res.data;
  },

  async axiosDeleteDataSetDocumentSegments(_, data) {
    const { dataset_id, document_id, segment_ids } = data;
    const res = await axios.delete(`${base}/datasets/${dataset_id}/documents/${document_id}/segments/batch`, {
      data: { segment_ids },
    });
    return res.data;
  },
  // end segments


  //SERVICES REQUESTS
  async getAxiosModelTypesLLM({ commit }) {
    const res = await axios.get(`${base}/models/llm-types`);
    commit('SET_MODEL_TYPES_LLM', res?.data?.data || []);
  },

  async getModelsParamRules({ commit }, { model, provider }) {
    const res = await axios.get(`${base}/models/param-rules`, {
      params: { model, provider },
    });
    commit('SET_CURRENT_MODEL_PARAM_RULES', res?.data?.data || []);
  },

  async getAxiosDatasetsProcessRule({ commit }) {
    const res = await axios.get(`${base}/datasets/_process-rule`);
    commit('SET_DATA_SETS_PROCESS_RULE', res?.data?.data);
  },

  async FLLUploadFile(_, data) {
	  const {
		  source,
		  file,
	  } = data

	  const url = `${base}/files/upload`;

	  try {
		  const formData = new FormData()
		  formData.append('file', file)

		  const response = await axios.post(
			  url,
			  formData,
			  {
				  headers: {
					  'Content-Type': 'application/json'
				  },
				  params: {
					  source: source,
				  },
			  },
		  )
		  console.log('The document is successfully loaded:', response.data?.data)
		  return response.data?.data
	  } catch (error) {
		  console.error('Document loading error:', error.response?.data || error.message)
		  throw error
	  }
  },
  //end SERVICES REQUESTS
};


const getters = {
	fll_ai_agents_list: (state) => state.fast_line_lite.ai_agents_list,
	fll_current_ai_agent: (state) => state.fast_line_lite.current_ai_agent,

	fll_data_sets_list: (state) => state.fast_line_lite.data_sets_list,
	fll_data_sets_process_rule: (state) => state.fast_line_lite.data_sets_process_rule,
	fll_current_data_set: (state) => state.fast_line_lite.current_data_set,
	fll_current_data_set_documents: (state) => state.fast_line_lite.current_data_set_documents,

	fll_current_dataset_document_segments: (state) => state.fast_line_lite.current_dataset_document_segments,

	fll_model_types_llm: (state) => state.fast_line_lite.model_types_llm,

	fll_current_model_param_rules: (state) => state.fast_line_lite.current_model_param_rules,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
